import { Grid, Typography, TypographyProps } from '@mui/material';
import React from 'react';

interface ChartTitleProps extends Omit<TypographyProps, 'children'> {
  title: string;
  extraContent?: React.ReactNode;
}

export const ChartTitle = ({ title, extraContent }: ChartTitleProps) => (
  <Grid
    container
    sx={{
      flexWrap: 'nowrap',
      alignItems: 'center',
      gap: 1,
      minWidth: 0,
      width: '100%',
      zIndex: 1,
    }}
  >
    <Grid item sx={{ flexShrink: 1, minWidth: 0 }}>
      <Typography
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {title}
      </Typography>
    </Grid>
    {extraContent && (
      <Grid item sx={{ flexShrink: 0 }}>
        {extraContent}
      </Grid>
    )}
  </Grid>
);
